export default class Crawler {
    list = [];
    state = false;
    
    constructor() {
        setTimeout(this.run.bind(this), 250);
    }
    
    async run() {
        if (this.list.length) {
            console.debug('working', {'queue': this.list.length});
            this.state = true;
            await this.list.shift()();
        } else {
            console.debug('idle');
            this.state = false;
            await sleep(1000);
        }
        
        setTimeout(this.run.bind(this), 100);
    }
    
    append(handler) {
        this.list.push(() => {
            return new Promise(async (resolve) => {
                await handler(resolve);
            });
        });
    }
    
    prepend(handler) {
        this.list.unshift(() => {
            return new Promise(async (resolve) => {
                await handler(resolve);
            });
        });
    }
}
